import { FC, ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFeatureFlag } from 'Hooks/useFeatureFlag';
import { ApisEnumLabel } from 'Data/enums/Apis';
import { Icon } from 'Components/UI';
import Button from 'Components/UI/Button';
import { CustomPopover, Modal } from './styles';

interface IErrorSAConnection {
  children: ReactNode;
  platform: number;
  triggered?: boolean;
  userRole?: number;
  onAction: () => void;
}

const ErrorSAConnection: FC<IErrorSAConnection> = ({
  children,
  platform,
  triggered,
  userRole,
  onAction,
}) => {
  const { t } = useTranslation('disciplinas');
  const disciplineSAErrorBlogUrlFlag = useFeatureFlag('discipline-sa-error-blog-url');
  const diciplineSAErrorUrl = (disciplineSAErrorBlogUrlFlag.enabled && typeof disciplineSAErrorBlogUrlFlag.value === 'string')
    ? disciplineSAErrorBlogUrlFlag.value
    : 'https://www.maletadoengenheiro.com.br/blog';

  const [visible, setVisible] = useState<boolean>();

  const hide = () => {
    setVisible(false);
  };

  const handleVisibleChange = (visible: boolean) => {
    setVisible(visible);
  };

  const handleAction = () => {
    onAction();
    hide();
  }

  const api = ApisEnumLabel[platform];

  const overlay = (
    <Modal>
      <div className="Wrapper">
        <div className="content">
          <div className="iconBox">
            <h4 className="title">
              {t('errorSAConnection.titleAdmin', { api })}
            </h4>
            <Icon
              icon="cancelar"
              customSize={12}
              color="cinzaOpaco"
              onClick={hide}
              className="closeIcon"
            />
          </div>

          <p className="description">
            {userRole === 1
              ? t('errorSAConnection.descriptionAdmin', { api })
              : t('errorSAConnection.descriptionUser', { api })
            }
          </p>
        </div>

        <div className="Footer">
          <div className="link">
            <a
              href={diciplineSAErrorUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('errorSAConnection.learnMore')}
            </a>
          </div>
          <Button
            type="primary"
            onClick={userRole === 1 ? handleAction : hide}
            className="buttonAction"
          >
            {userRole === 1 ? t('errorSAConnection.fixError') : t('errorSAConnection.close')}
          </Button>
        </div>
      </div>
    </Modal>
  );

  return (
    <CustomPopover
      content={overlay}
      placement="bottomLeft"
      trigger="click"
      open={triggered ? false : visible}
      onOpenChange={handleVisibleChange}
      overlayInnerStyle={{ padding: 0 }}
    >
      {children}
    </CustomPopover>
  );
}

export default ErrorSAConnection;
